export const checkForFullDimensionInUrl = () =>
    location.pathname.match(/\/[0-9]+-[0-9]+-r[0-9]+\//);
